<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells><app-button @click.native="onShowModal(null)">Create EFD receipt</app-button></app-cells>
      <app-cells>
        <app-input
          @input.native="onReceiptSearch"
          v-model="filter_search"
          class="input--300"
          type="search"
          placeholder="Search"
          name="search"
        />
        <VueCtkDateTimePicker
          id="date_picker_leads_request"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          @is-hidden="fetchAll"
          @input="onInputDatePicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Date range"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          ref="date_picker"
        />
        <app-select
          @search="onSupplierSearch"
          @input="onChangeFilter"
          v-model="filter_supplier"
          :options="supplier_options"
          :filterBy="() => true"
          :display-field="option => `${option.trade_name === option.legal_name ? option.trade_name : `${option.trade_name} (${option.legal_name})`}`"
          label="trade_name"
          placeholder="Supplier"
          class="select--300"
        />
        <app-select
          @input="onChangeFilter"
          v-model="filter_legal_entity"
          :options="legalEntities"
          :reduce="item => item.code"
          label="short_name"
          placeholder="Legal entity"
          class="select--300"
        />
      </app-cells>
<!--      <app-cells><h2 class="title">Verified</h2></app-cells>-->
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__verification_code><div class="table-default__left">Verification code</div></template>
        <template #h__supplier><div class="table-default__left">Supplier</div></template>
        <template #source="{ row }">{{ row.source.name }}</template>
        <template #status="{ row }">
          <div class="table-default__controls">
            <span
              class="table-default__activity table-default__activity--tra"
              :class="{'table-default__activity--active': row.tra_record}"
            />
            <span
              class="table-default__activity table-default__activity--vat"
              :class="{'table-default__activity--active': row.vat_record}"
            />
          </div>
        </template>
        <template #verification_code="{ row }">
          <div class="table-default__left">
            <button
              @click="onCopyToClipboard(row.verification_link)"
              class="table-default__copy"
              :class="{'table-default__copy--disabled': !row.verification_link}"
            >
              {{ row.verification_code }}
            </button>
          </div>
        </template>
        <template #date="{ row }"><span class="table-default__nowrap">{{ dateFormat(row.date) }}</span></template>
        <template #time="{ row }">{{ row.time || '-' }}</template>
        <template #supplier="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'administrative-suppliers-detail-purchases', params: { id: row.supplier.id } }"
              class="table-default__link-inline"
            >
              {{ row.supplier.trade_name }}
            </router-link>
          </div>
        </template>
        <template #amount_total="{ row }">{{ formatAmount(row.amount_total) }}</template>
        <template #amount_vat_exc="{ row }">{{ formatAmount(row.amount_vat_exc) }}</template>
        <template #amount_vat="{ row }">{{ formatAmount(row.amount_vat) }}</template>
        <template #amount_exempted="{ row }">{{ formatAmount(row.amount_exempted) }}</template>
        <template #receipt_copy="{ row }">
          <a
            :class="{'table-default__disabled': !row.receipt_copy}"
            :href="row.receipt_copy?.file"
            target="_blank"
          >
            <img alt="Attachment" src="@/assets/img/snacks-link.svg">
          </a>
        </template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowModal(row)" type="button">
              <img src="@/assets/img/edit-table-icon.svg" alt="Edit">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
<!--      <app-cells><h2 class="title">Not verified</h2></app-cells>-->
<!--      <v-client-table-->
<!--        :data="table_not.items"-->
<!--        :columns="table_not.columns"-->
<!--        :options="table_not.options"-->
<!--        class="table-default"-->
<!--        :class="{ 'table-default&#45;&#45;loading': table_not_preloader }"-->
<!--      >-->
<!--        <template #h__fr><div class="table-default__left">FR</div></template>-->
<!--        <template #fr="{ row }">-->
<!--          <div class="table-default__left">-->
<!--            <router-link-->
<!--              v-if="row.fund_request"-->
<!--              :to="{ name: 'finance-fund-requests-detail-items', params: { id: row.fund_request.id } }"-->
<!--              class="table-default__link-border"-->
<!--            >-->
<!--              #{{ row.fund_request.id }}-->
<!--            </router-link>-->
<!--            <span v-else>-</span>-->
<!--          </div>-->
<!--        </template>-->
<!--        <template #verification_code="{ row }">-->
<!--          <button-->
<!--            @click="onCopyToClipboard(row.tra_link)"-->
<!--            class="table-default__copy"-->
<!--            :class="{'table-default__copy&#45;&#45;disabled': !row.tra_link}"-->
<!--          >-->
<!--            {{ row.verification_code }}-->
<!--          </button>-->
<!--        </template>-->
<!--        <template #timestamp="{ row }">{{ dateFormat(row.timestamp) }}</template>-->
<!--        <template #amount_total="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_total) }}</template>-->
<!--        <template #amount_vat_exc="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_vat_exc) }}</template>-->
<!--        <template #amount_vat="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_vat) }}</template>-->
<!--        <template #amount_exempted="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_exempted) }}</template>-->
<!--        <template #receipt_copy="{ row }">-->
<!--          <div class="table-default__controls">-->
<!--            <button-->
<!--              @click="onDownloadFile(row.receipt_copy, row)"-->
<!--              type="button"-->
<!--            >-->
<!--              <img src="@/assets/img/download-table-blue-icon.svg" alt="">-->
<!--            </button>-->
<!--          </div>-->
<!--        </template>-->
<!--      </v-client-table>-->
<!--      <app-cells position="between">-->
<!--        <div>-->
<!--          <paginate-->
<!--            :clickHandler="onClickPaginationNot"-->
<!--            v-if="pagination_not.pages > 1"-->
<!--            v-model="pagination_not.page"-->
<!--            :page-count="pagination_not.pages"-->
<!--            :prev-text="'<'"-->
<!--            :next-text="'>'"-->
<!--            :container-class="'pagination'"-->
<!--            :page-class="'pagination__item'"-->
<!--            :page-link-class="'pagination__link'"-->
<!--            :prev-class="'pagination__item pagination__item&#45;&#45;prev'"-->
<!--            :next-class="'pagination__item pagination__item&#45;&#45;next'"-->
<!--            :next-link-class="'pagination__link pagination__link&#45;&#45;next'"-->
<!--            :prev-link-class="'pagination__link pagination__link&#45;&#45;prev'"-->
<!--          />-->
<!--        </div>-->
<!--        <app-table-records :all="pagination_not.count" :count="table_not.items.length" :page="pagination_not.page" />-->
<!--      </app-cells>-->
<!--      <app-cells><h2 class="title">Attention</h2></app-cells>-->
<!--      <v-client-table-->
<!--        :data="table_attention.items"-->
<!--        :columns="table_attention.columns"-->
<!--        :options="table_attention.options"-->
<!--        class="table-default"-->
<!--        :class="{ 'table-default&#45;&#45;loading': table_attention_preloader }"-->
<!--      >-->
<!--        <template #h__fr><div class="table-default__left">FR</div></template>-->
<!--        <template #fr="{ row }">-->
<!--          <div class="table-default__left">-->
<!--            <router-link-->
<!--              v-if="row.fund_request"-->
<!--              :to="{ name: 'finance-fund-requests-detail-items', params: { id: row.fund_request.id } }"-->
<!--              class="table-default__link-border"-->
<!--            >-->
<!--              #{{ row.fund_request.id }}-->
<!--            </router-link>-->
<!--            <span v-else>-</span>-->
<!--          </div>-->
<!--        </template>-->
<!--        <template #verification_code="{ row }">-->
<!--          <button-->
<!--            @click="onCopyToClipboard(row.tra_link)"-->
<!--            class="table-default__copy"-->
<!--            :class="{'table-default__copy&#45;&#45;disabled': !row.tra_link}"-->
<!--          >-->
<!--            {{ row.verification_code }}-->
<!--          </button>-->
<!--        </template>-->
<!--        <template #timestamp="{ row }">{{ dateFormat(row.timestamp) }}</template>-->
<!--        <template #amount_total="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_total) }}</template>-->
<!--        <template #amount_vat_exc="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_vat_exc) }}</template>-->
<!--        <template #amount_vat="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_vat) }}</template>-->
<!--        <template #amount_exempted="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_exempted) }}</template>-->
<!--        <template #receipt_copy="{ row }">-->
<!--          <div class="table-default__controls">-->
<!--            <button-->
<!--              @click="onDownloadFile(row.receipt_copy, row)"-->
<!--              type="button"-->
<!--            >-->
<!--              <img src="@/assets/img/download-table-blue-icon.svg" alt="">-->
<!--            </button>-->
<!--          </div>-->
<!--        </template>-->
<!--      </v-client-table>-->
<!--      <app-cells position="between">-->
<!--        <div>-->
<!--          <paginate-->
<!--            :clickHandler="onClickPaginationAttention"-->
<!--            v-if="pagination_attention.pages > 1"-->
<!--            v-model="pagination_attention.page"-->
<!--            :page-count="pagination_attention.pages"-->
<!--            :prev-text="'<'"-->
<!--            :next-text="'>'"-->
<!--            :container-class="'pagination'"-->
<!--            :page-class="'pagination__item'"-->
<!--            :page-link-class="'pagination__link'"-->
<!--            :prev-class="'pagination__item pagination__item&#45;&#45;prev'"-->
<!--            :next-class="'pagination__item pagination__item&#45;&#45;next'"-->
<!--            :next-link-class="'pagination__link pagination__link&#45;&#45;next'"-->
<!--            :prev-link-class="'pagination__link pagination__link&#45;&#45;prev'"-->
<!--          />-->
<!--        </div>-->
<!--        <app-table-records :all="pagination_attention.count" :count="table_attention.items.length" :page="pagination_attention.page" />-->
<!--      </app-cells>-->
    </template>
    <modal
      name="receipt-modal"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('receipt-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">{{ receipt_to_action ? 'Update' : 'Create' }} receipt</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm" :key="repaint_key">
            <app-grid>
              <template #item-1>
                <app-form-group label="Legal entity" required>
                  <app-select
                    v-model="form.legal_entity"
                    :options="legalEntities"
                    :clearable="false"
                    label="short_name"
                    placeholder="Legal entity"
                    :error="$v.form.legal_entity.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.legal_entity.$dirty && !$v.form.legal_entity.required">Required field</div>
                  </template>
                </app-form-group>
                <app-cells :indent="false" :wrap="false">
                  <app-form-group label="Date" required>
                    <app-date-picker
                      v-model="form.date"
                      :clearable="false"
                      placeholder="Date"
                      :disabled-date="disableFutureDates"
                      :error="$v.form.date.$error"
                    />
                    <template #error>
                      <div v-if="$v.form.date.$dirty && !$v.form.date.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Time" :required="!receipt_to_action">
                    <app-input
                      v-model="form.time"
                      v-mask="'99:99:99'"
                      placeholder="00:00:00"
                      autocomplete="off"
                      id="time"
                      name="time"
                      @paste.native.prevent
                      :error="$v.form.time.$error"
                    />
                    <template #error>
                      <div v-if="$v.form.time.$dirty && !$v.form.time.timeRegex">Wrong time</div>
                      <div v-if="$v.form.time.$dirty && !$v.form.time.required">Required field</div>
                    </template>
                  </app-form-group>
                </app-cells>
                <app-form-group label="Verification code" label-for="code" required>
                  <app-input
                    v-model="form.verification_code"
                    :error="$v.form.verification_code.$error"
                    id="code"
                    placeholder="Verification code"
                    name="code"
                  />
                  <template #error>
                    <div v-if="$v.form.verification_code.$dirty && !$v.form.verification_code.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Receipt copy" required>
                  <app-uploader
                    v-model="form.receipt_copy"
                    :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
                    formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
                    class="custom-uploader--flex"
                  />
                  <template #error>
                    <div v-if="$v.form.receipt_copy.$dirty && !$v.form.receipt_copy.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group v-if="!receipt_to_action">
                  <app-checkbox
                    v-model="allocate_invoices"
                    label="Allocate Invoices"
                    :readonly="!form.amount_total"
                  />
                </app-form-group>
              </template>
              <template #item-2>
                <app-form-group label="Supplier" required>
                  <app-select
                    @search="onSupplierSearch"
                    @input="onChangeSupplier"
                    v-model="form.supplier"
                    :options="supplier_options"
                    :clearable="false"
                    :display-field="option => `${option.trade_name === option.legal_name ? option.trade_name : `${option.trade_name} (${option.legal_name})`}`"
                    :readonly="allocate_invoices"
                    label="trade_name"
                    placeholder="Supplier"
                    :error="$v.form.supplier.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.supplier.$dirty && !$v.form.supplier.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group v-if="form.supplier" label="Total amount" label-for="amount_total" required>
                  <app-fin-number
                    @change.native="onChangeTotal"
                    v-model="form.amount_total"
                    :readonly="allocate_invoices"
                    id="amount_total"
                    name="amount_total"
                    key="amount_total"
                    :error="$v.form.amount_total.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.amount_total.$dirty && !$v.form.amount_total.required">Required field</div>
                  </template>
                </app-form-group>
                <template v-if="form.supplier?.vat === true">
                  <app-form-group label="Exempted" label-for="amount_exempted" required>
                    <app-fin-number
                      @change.native="onChangeExempted"
                      v-model="form.amount_exempted"
                      :readonly="allocate_invoices"
                      id="amount_exempted"
                      name="amount_exempted"
                      :error="$v.form.amount_exempted.$error"
                    />
                    <template #error>
                      <div v-if="$v.form.amount_exempted.$dirty && !$v.form.amount_exempted.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="VAT" label-for="amount_vat" required>
                    <template #additional>
                      <app-checkbox
                        v-model="manual_adjustment"
                        label="Manual Adjustment"
                      />
                    </template>
                    <app-fin-number
                      v-model="form.amount_vat"
                      :error="$v.form.amount_vat.$error"
                      id="amount_vat"
                      name="amount_vat"
                      :readonly="!manual_adjustment"
                    />
                    <template #error>
                      <div v-if="$v.form.amount_vat.$dirty && !$v.form.amount_vat.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Excluded VAT" label-for="amount_vat_exc" required>
                    <app-fin-number
                      v-model="form.amount_vat_exc"
                      :error="$v.form.amount_vat_exc.$error"
                      id="amount_vat_exc"
                      name="amount_vat_exc"
                      :readonly="!manual_adjustment"
                    />
                    <template #error>
                      <div v-if="$v.form.amount_vat_exc.$dirty && !$v.form.amount_vat_exc.required">Required field</div>
                    </template>
                  </app-form-group>
                </template>
                <app-form-group v-if="form.supplier?.vat === false" label="Non-creditable" label-for="non_creditable_amount">
                  <app-fin-number
                    v-model="form.non_creditable_amount"
                    id="non_creditable_amount"
                    name="non_creditable_amount"
                    key="non_creditable_amount"
                    readonly
                  />
                </app-form-group>
              </template>
            </app-grid>
            <div v-if="allocate_invoices" class="arrange-popup__part">
              <div class="arrange-popup__block-title arrange-popup__block-title--fz13">
                <span>
                  Unallocated Amount:
                  <span :style="{ 'color':unallocated_amount > 0 ? '#e85c20' : '#77b017' }">{{ formatAmount(unallocated_amount) }}</span>
                </span>
              </div>
              <div class="transfer-sortable transfer-sortable--full">
                <div v-for="(element, index) in form.allocations" :key="`own_item_${index}`" class="transfer-sortable__item transfer-sortable__item--mb-20">
                  <app-flex-grid :rows="[[1, '120px', '120px']]" margin-bottom="0" alignItems="start">
                    <template #col-1-1>
                      <app-form-group label="Invoice" class="form-group--no-indent" required>
                        <app-select
                          @search="onInvoiceSearch"
                          v-model="element.supplier_invoice"
                          :options="supplier_invoice_options"
                          :clearable="false"
                          :display-field="option => `${option.invoice_number} (${dateFormat(option.date)})`"
                          label="invoice_number"
                          placeholder="Invoice"
                          :error="$v.form.allocations.$each[index].supplier_invoice.$error"
                        />
                        <template #error>
                          <div v-if="$v.form.allocations.$each[index].supplier_invoice.$dirty && !$v.form.allocations.$each[index].supplier_invoice.required">Required field</div>
                        </template>
                      </app-form-group>
                    </template>
                    <template #col-1-2>
                      <app-form-group label="Amount (TZS)" :label-for="`amount-tzs-${index}`" class="form-group--no-indent">
                        <app-fin-number
                          v-if="!element.supplier_invoice"
                          readonly
                        />
                        <app-fin-number
                          v-else
                          v-model="element.supplier_invoice.amount_total_tzs"
                          :id="`amount-tzs-${index}`"
                          readonly
                        />
                      </app-form-group>
                    </template>
                    <template #col-1-3>
                      <app-form-group label="Amount" :label-for="`amount-${index}`" required class="form-group--no-indent">
                        <app-fin-number
                          v-model="element.amount"
                          :id="`amount-${index}`"
                          :error="$v.form.allocations.$each[index].amount.$error"
                        />
                        <template #error>
                          <div v-if="$v.form.allocations.$each[index].amount.$dirty && !$v.form.allocations.$each[index].amount.required">Required field</div>
                        </template>
                      </app-form-group>
                    </template>
                  </app-flex-grid>
                  <button
                    v-if="index"
                    @click="onRemoveItem(index)"
                    class="transfer-sortable__close"
                    type="button"
                  >
                    <img src="@/assets/img/delete-transfer.svg" alt="">
                  </button>
                  <button v-if="!index" @click="onAddItem" type="button" class="transfer-sortable__add"></button>
                </div>
              </div>
            </div>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">{{ receipt_to_action ? 'Save' : 'Create' }}</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import {
  getAdministrativeSuppliers,
  getEmployeesListSearch,
  getFinanceSupplierInvoiceList,
  getFinanceSuppliersEFDReceipts,
  patchFinanceEFDReceipt,
  postFinanceEFDReceipt,
} from '@/http'
import debounce from 'lodash/debounce'
import {format, parseISO} from 'date-fns'
import {helpers, required, requiredIf} from 'vuelidate/lib/validators'

const truncateToTwo = num => Math.floor(num * 100) / 100
const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])?$/i)

export default {
  name: 'FinanceEFDReceipts',
  props: ['legalEntities'],
  components: { VueCtkDateTimePicker },
  data() {
    return {
      manual_adjustment: false,
      allocate_invoices: false,
      page_loaded: false,
      filter_search: '',
      filter_dates: null,
      filter_supplier: null,
      filter_legal_entity: null,
      repaint_key: 1,
      amount_total: '',
      custom_shortcuts: [
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      supplier_options: [],
      business_unit_options: [],
      expense_item_options: [],
      responsible_options: [],
      supplier_invoice_options: [],
      table: {
        items: [],
        columns: [
          'receipt_copy',
          'source',
          'status',
          'verification_code',
          'date',
          'time',
          'supplier',
          'amount_total',
          'amount_vat_exc',
          'amount_vat',
          'amount_exempted',
          'controls'
        ],
        options: {
          headings: {
            'receipt_copy': 'Receipt',
            'source': 'Source',
            'status': 'Status',
            'verification_code': 'Verification code',
            'date': 'Date',
            'time': 'Time',
            'supplier': 'Supplier',
            'amount_total': 'Total amount',
            'amount_vat_exc': 'VAT Exclude',
            'amount_vat': 'VAT',
            'amount_exempted': 'Exempted',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
      table_not: {
        items: [],
        columns: [
          'fr',
          'verification_code',
          'timestamp',
          'legal_entity.name',
          'supplier',
          'amount_total',
          'amount_vat_exc',
          'amount_vat',
          'amount_exempted',
          'receipt_copy'
        ],
        options: {
          headings: {
            'fr': 'FR',
            'verification_code': 'Verification code',
            'timestamp': 'Date',
            'legal_entity.name': 'Legal entity',
            'supplier': 'Supplier',
            'amount_total': 'Total amount',
            'amount_vat_exc': 'VAT Exclude',
            'amount_vat': 'VAT',
            'amount_exempted': 'Exempted',
            'receipt_copy': 'Receipt',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_not: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_not_preloader: false,
      table_attention: {
        items: [],
        columns: [
          'fr',
          'verification_code',
          'timestamp',
          'legal_entity.name',
          'supplier.trade_name',
          'amount_total',
          'amount_vat_exc',
          'amount_vat',
          'amount_exempted',
          'receipt_copy',
        ],
        options: {
          headings: {
            'fr': 'FR',
            'verification_code': 'Verification code',
            'timestamp': 'Date',
            'legal_entity.name': 'Legal entity',
            'supplier.trade_name': 'Supplier',
            'amount_total': 'Total amount',
            'amount_vat_exc': 'VAT Exclude',
            'amount_vat': 'VAT',
            'amount_exempted': 'Exempted',
            'receipt_copy': 'Receipt',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_attention: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_attention_preloader: false,
      receipt_to_action: null,
      form: {},
    }
  },
  validations: {
    form: {
      legal_entity: { required },
      supplier: { required },
      date: { required },
      time: {
        required: requiredIf(function() {
          return !this.receipt_to_action
        }),
        timeRegex
      },
      verification_code: { required },
      amount_total: { required },
      amount_exempted: {
        required: requiredIf(function() {
          return this.form.supplier?.vat
        })
      },
      amount_vat: {
        required: requiredIf(function() {
          return this.form.supplier?.vat
        })
      },
      amount_vat_exc: {
        required: requiredIf(function() {
          return this.form.supplier?.vat
        })
      },
      receipt_copy: { required },
      allocations: {
        $each: {
          supplier_invoice: {
            required: requiredIf(function() {
              return !this.receipt_to_action && this.allocate_invoices
            })
          },
          amount: {
            required: requiredIf(function() {
              return !this.receipt_to_action && this.allocate_invoices
            })
          },
        }
      },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    unallocated_amount() {
      const sum = this.form.allocations
        .map(item => parseFloat(item.amount) || 0)
        .reduce((a, b) => {
          return a + b
        }, 0)
      return parseFloat(this.form.amount_total) - sum
    }
  },
  created() {
    this.fetchItems().then(() => {
      this.page_loaded = true
    })
  },
  methods: {
    onChangeSupplier() {
      this.form.amount_total = ''
      this.form.amount_exempted = ''
      this.form.amount_vat = ''
      this.form.amount_vat_exc = ''
      this.form.non_creditable_amount = ''
      this.repaint_key += 1
    },
    calculateVAT() {
      const rate = 18 / 118
      // const vat = (((parseFloat(this.form.amount_total) || 0) - (parseFloat(this.form.amount_exempted) || 0)) * rate).toFixed(2)
      // let [integerPart, decimalPart] = vat.split('.')
      // integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      // if (decimalPart) decimalPart = decimalPart.slice(0, 2)
      this.form.amount_vat = (((parseFloat(this.form.amount_total) || 0) - (parseFloat(this.form.amount_exempted) || 0)) * rate).toFixed(2)
      this.form.amount_vat_exc = ((parseFloat(this.form.amount_total) || 0) - (parseFloat(this.form.amount_exempted) || 0) - parseFloat(this.form.amount_vat)).toFixed(2)
    },
    onChangeExempted() {
      this.calculateVAT()
      this.repaint_key += 1
    },
    onChangeTotal() {
      if (this.form.supplier?.vat === false) {
        this.form.non_creditable_amount = this.form.amount_total
      } else {
        this.calculateVAT()
      }
      this.repaint_key += 1
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      const data = {
        ...this.form,
        legal_entity: this.form.legal_entity.code,
        receipt_copy: this.form.receipt_copy.id,
      }
      data.non_creditable_amount = !data.supplier.vat && data.non_creditable_amount ? truncateToTwo(parseFloat(data.non_creditable_amount)) : 0
      data.amount_vat_exc = data.supplier.vat && data.amount_vat_exc ? truncateToTwo(parseFloat(data.amount_vat_exc)) : 0
      data.amount_vat = data.supplier.vat && data.amount_vat ? truncateToTwo(parseFloat(data.amount_vat)) : 0
      data.amount_exempted = data.supplier.vat && data.amount_exempted ? truncateToTwo(parseFloat(data.amount_exempted)) : 0
      data.amount_total = data.supplier.vat && data.amount_total ? truncateToTwo(parseFloat(data.amount_total)) : 0
      data.supplier = data.supplier.id
      delete data.source
      if (!this.allocate_invoices) delete data.allocations
      else data.allocations = data.allocations.map(({amount, supplier_invoice}) => ({amount, supplier_invoice: supplier_invoice.id}))
      if (this.receipt_to_action) {
        patchFinanceEFDReceipt(this.receipt_to_action.id, data)
          .then(() => {
            this.fetchItems()
            this.$notify({
              type: 'success',
              title: 'Receipt updated',
            })
            this.$modal.hide('receipt-modal')
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else {
        postFinanceEFDReceipt(data)
          .then(() => {
            this.fetchItems()
            this.$notify({
              type: 'success',
              title: 'Receipt created',
            })
            this.$modal.hide('receipt-modal')
          })
          .catch(() => { this.$refs.submit.preload = false })
      }
    },
    onShowModal(receipt) {
      this.receipt_to_action = receipt
      this.allocate_invoices = false
      if (receipt) {
        this.form = {
          legal_entity: receipt.legal_entity,
          supplier: receipt.supplier,
          date: receipt.date,
          time: receipt.time,
          verification_code: receipt.verification_code,
          amount_total: receipt.amount_total || '',
          amount_vat_exc: receipt.supplier.vat ? receipt.amount_vat_exc : '',
          amount_vat: receipt.supplier.vat ? receipt.amount_vat : '',
          amount_exempted: receipt.supplier.vat ? receipt.amount_exempted : '',
          non_creditable_amount: !receipt.supplier.vat ? receipt.non_creditable_amount : '',
          receipt_copy: receipt.receipt_copy,
          source: receipt.source,
        }
      } else {
        this.form = {
          legal_entity: this.legalEntities[0],
          amount_vat_exc: '',
          amount_vat: '',
          amount_exempted: '',
          non_creditable_amount: '',
          amount_total: '',
          allocations: [{}]
        }
      }
      this.$v.form.$reset()
      this.$modal.show('receipt-modal')
    },
    onAddItem() {
      this.form.allocations.push({})
    },
    onRemoveItem(index) {
      this.form.allocations.splice(index, 1)
    },
    fetchAll() {
      this.fetchItems()
      // this.fetchItemsNot()
      // this.fetchItemsAttention()
    },
    async fetchItems() {
      const response = await getFinanceSuppliersEFDReceipts({
        page: this.pagination.page,
        page_size: 20,
        // verified: true,
        // amount_match: true,
        search: this.filter_search,
        supplier: this.filter_search ? '' : this.filter_supplier?.id,
        legal_entity: this.filter_search ? '' : this.filter_legal_entity,
        from_date: this.filter_search ? '' : this.filter_dates?.start,
        to_date: this.filter_search ? '' : this.filter_dates?.end,
      })
      this.table.items = response.data.results
      this.pagination.pages = response.data.pages
      this.pagination.count = response.data.count
      this.table_preloader = false
    },
    async fetchItemsNot() {
      const response = await getFinanceSuppliersEFDReceipts({
        page: this.pagination.page,
        page_size: 20,
        verified: false,
        ordering: 'timestamp',
        search: this.filter_search,
        supplier: this.filter_search ? '' : this.filter_supplier?.id,
        legal_entity: this.filter_search ? '' : this.filter_legal_entity,
        from_date: this.filter_search ? '' : this.filter_dates?.start,
        to_date: this.filter_search ? '' : this.filter_dates?.end,
      })
      this.table_not.items = response.data.results
      this.pagination_not.pages = response.data.pages
      this.pagination_not.count = response.data.count
      this.table_not_preloader = false
    },
    async fetchItemsAttention() {
      const response = await getFinanceSuppliersEFDReceipts({
        page: this.pagination.page,
        page_size: 20,
        verified: true,
        amount_match: false,
        ordering: 'timestamp',
        search: this.filter_search,
        supplier: this.filter_search ? '' : this.filter_supplier?.id,
        legal_entity: this.filter_search ? '' : this.filter_legal_entity,
        from_date: this.filter_search ? '' : this.filter_dates?.start,
        to_date: this.filter_search ? '' : this.filter_dates?.end,
      })
      this.table_attention.items = response.data.results
      this.pagination_attention.pages = response.data.pages
      this.pagination_attention.count = response.data.count
      this.table_attention_preloader = false
    },
    onInputDatePicker() {
      if (!this.$refs.date_picker.pickerOpen) this.fetchAll()
    },
    onChangeFilter() {
      this.pagination.page = 1
      this.pagination_not.page = 1
      this.pagination_attention.page = 1
      this.filter_search = ''
      this.fetchAll()
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    onClickPaginationNot(page) {
      this.table_not_preloader = true
      this.pagination_not.page = page
      this.fetchItemsNot()
    },
    onClickPaginationAttention(page) {
      this.table_attention_preloader = true
      this.pagination_attention.page = page
      this.fetchItemsAttention()
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
    onCopyToClipboard(string) {
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    formatAmount(amount) {
      return new Intl.NumberFormat('ru-RU').format(amount)
    },
    disableFutureDates(date) {
      const d = this.normalizeDate(date)
      const today = this.normalizeDate(new Date())
      return d > today
    },
    normalizeDate(val) {
      const date = new Date(val)
      date.setHours(0, 0, 0, 0)
      return date
    },
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getAdministrativeSuppliers({search})
          .then(response => {
            vm.supplier_options = response.data
            loading(false)
          })
      }
    }, 500),
    onEmployeeSearch(search, loading) {
      loading(true)
      this.searchEmployee(loading, search, this)
    },
    searchEmployee: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.responsible_options = []
      } else {
        getEmployeesListSearch({search}).then(response => {
          vm.responsible_options = response.data
          loading(false)
        })
      }
    }, 350),
    onReceiptSearch() {
      this.searchReceipt(this)
    },
    searchReceipt: debounce(vm => {
      vm.pagination.page = 1
      vm.pagination_not.page = 1
      vm.pagination_attention.page = 1
      vm.fetchAll()
    }, 350),
    onInvoiceSearch(search, loading) {
      loading(true)
      this.searchInvoice(loading, search, this)
    },
    searchInvoice: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_invoice_options = []
      } else {
        getFinanceSupplierInvoiceList({search, efd_covered: false, supplier: vm.form.supplier.id})
          .then(response => {
            vm.supplier_invoice_options = response.data
            loading(false)
          })
      }
    }, 500),
  }
}
</script>
